/* Pestañas con separación de tablas técnicas importadas y navegación accesible. */
if (!customElements.get('ep-product-tabs')) {
  customElements.define('ep-product-tabs', class extends HTMLElement {
    normalize(value) {
      return String(value || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/\s+/g, ' ').trim().toLowerCase();
    }

    prepareTechnicalContent() {
      const description = this.querySelector('[data-description-content]');
      const technicalContent = this.querySelector('[data-technical-content]');
      const technicalTab = this.querySelector('[data-technical-tab]');
      const technicalPanel = this.querySelector('[data-product-panel="technical"]');
      if (!technicalContent || !technicalTab || !technicalPanel) return;

      if (this.dataset.technicalConfigured !== 'true' && description) {
        /* Solo se separan tablas reconocidas de la importación comprobada. */
        const importedTables = Array.from(description.querySelectorAll('table.woocommerce-technical-specs'));
        for (const table of importedTables) {
          const previous = table.previousElementSibling;
          if (previous && /^H[1-6]$/.test(previous.tagName) && this.normalize(previous.textContent) === 'ficha tecnica') {
            previous.remove();
          }
          for (const row of Array.from(table.rows)) {
            const cells = Array.from(row.cells);
            const texts = cells.map((cell) => this.normalize(cell.textContent));
            const comparisonControl = texts.some((value) => value.includes('añadir a comparar') || value.includes('anadir a comparar'));
            const importedContact = texts.some((value) => value.includes('soporte@technoplanet.es'));
            if (comparisonControl || importedContact) row.remove();
          }
          const meaningfulRows = Array.from(table.rows).filter((row) => Array.from(row.cells).some((cell) => cell.textContent.trim()));
          if (meaningfulRows.length) {
            table.classList.add('ep-product-specifications');
            technicalContent.append(table);
          } else {
            table.remove();
          }
        }
      }

      const hasTechnicalContent = Boolean(technicalContent.textContent.trim() || technicalContent.querySelector('img, video, iframe, object'));
      technicalTab.hidden = !hasTechnicalContent;
      technicalPanel.hidden = !hasTechnicalContent;
      const counter = technicalTab.querySelector('[data-specification-count]');
      if (counter) {
        const count = Array.from(technicalContent.querySelectorAll('tr')).filter((row) => {
          const cells = Array.from(row.cells);
          return cells.length >= 2 && cells.every((cell) => cell.textContent.trim());
        }).length;
        counter.textContent = count ? ` (${count})` : '';
        counter.hidden = !count;
      }
    }

    connectedCallback() {
      if (this.initialized) return;
      this.prepareTechnicalContent();
      this.navigation = this.querySelector('[data-tab-navigation]');
      this.tabs = Array.from(this.querySelectorAll('[data-product-tab]')).filter((tab) => !tab.hidden);
      this.panels = this.tabs.map((tab) => this.querySelector(`[id="${tab.getAttribute('aria-controls')}"]`));
      if (!this.navigation || !this.tabs.length || this.panels.some((panel) => !panel)) return;
      this.initialized = true;
      this.navigation.setAttribute('role', 'tablist');
      this.tabs.forEach((tab, index) => {
        tab.setAttribute('role', 'tab');
        this.panels[index].setAttribute('role', 'tabpanel');
        this.panels[index].setAttribute('aria-labelledby', tab.id);
        this.panels[index].setAttribute('tabindex', '0');
      });

      this.onClick = (event) => {
        const tab = event.target.closest('[data-product-tab]');
        if (!tab || !this.tabs.includes(tab)) return;
        event.preventDefault();
        this.activate(this.tabs.indexOf(tab));
      };
      this.onKeydown = (event) => {
        const currentIndex = this.tabs.indexOf(event.target.closest('[data-product-tab]'));
        if (currentIndex < 0) return;
        let nextIndex;
        switch (event.key) {
          case 'ArrowRight': nextIndex = (currentIndex + 1) % this.tabs.length; break;
          case 'ArrowLeft': nextIndex = (currentIndex + this.tabs.length - 1) % this.tabs.length; break;
          case 'Home': nextIndex = 0; break;
          case 'End': nextIndex = this.tabs.length - 1; break;
          case ' ':
          case 'Enter': nextIndex = currentIndex; break;
          default: return;
        }
        event.preventDefault();
        this.activate(nextIndex, true);
      };
      this.onHashchange = () => this.revealHash(window.location.hash);
      this.onDocumentClick = (event) => {
        const link = event.target.closest('a[href]');
        if (!link || !this.closest('product-info')?.contains(link)) return;
        const url = new URL(link.href, window.location.href);
        if (url.origin === window.location.origin && url.pathname === window.location.pathname && url.search === window.location.search) {
          this.revealHash(url.hash);
        }
      };
      this.onBlockSelect = (event) => {
        if (event.detail?.blockId === this.dataset.descriptionBlock) {
          const index = this.panels.findIndex((panel) => panel.dataset.productPanel === 'description');
          if (index >= 0) this.activate(index);
        }
      };
      this.addEventListener('click', this.onClick);
      this.addEventListener('keydown', this.onKeydown);
      window.addEventListener('hashchange', this.onHashchange);
      document.addEventListener('click', this.onDocumentClick);
      document.addEventListener('shopify:block:select', this.onBlockSelect);
      this.activate(0);
      this.revealHash(window.location.hash);
    }

    activate(index, moveFocus = false) {
      if (!this.tabs[index]) return;
      this.tabs.forEach((tab, tabIndex) => {
        const selected = index === tabIndex;
        tab.setAttribute('aria-selected', String(selected));
        tab.setAttribute('tabindex', selected ? '0' : '-1');
        this.panels[tabIndex].hidden = !selected;
      });
      if (moveFocus) this.tabs[index].focus();
    }

    revealHash(hash) {
      if (!hash || hash === '#') return;
      let id;
      try { id = decodeURIComponent(hash.slice(1)); } catch { return; }
      const target = document.getElementById(id);
      if (!target || !this.contains(target)) return;
      const index = this.panels.findIndex((panel) => panel === target || panel.contains(target));
      if (index >= 0) this.activate(index);
    }

    disconnectedCallback() {
      if (!this.initialized) return;
      this.removeEventListener('click', this.onClick);
      this.removeEventListener('keydown', this.onKeydown);
      window.removeEventListener('hashchange', this.onHashchange);
      document.removeEventListener('click', this.onDocumentClick);
      document.removeEventListener('shopify:block:select', this.onBlockSelect);
      this.initialized = false;
    }
  });
}
